<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Clock from "../Icons/Clock.svelte";
  import {
    getSuccessPageCopyKey,
    getSuccessPageData,
    navigateToAlreadyOrderedPhaseWhenOnAlreadyOrderedPhase
  } from "../../lib/helpers/steps/success";
  import { campaignUserStore } from "../../lib/stores/campaignUser";
  import { getCopy } from "../../lib/stores/copy";
  import { navigateToPath } from "../../lib/routing";
  import PATHS from "../../lib/constants/routePaths";
  import { getCampaignUser } from "../../lib/helpers/campaignUserManager";
  import LoadingScreen from "../LoadingScreen.svelte";
  import Button from "../Button.svelte";
  import CustomHtml from "../CustomHTML.svelte";
  import { onMount } from "svelte";
  import isEmpty from "lodash/isEmpty";
  import { clearAllowListExceptTheCurrentRoute } from "../../lib/routing/index";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;
  let isLoading = false;

  onMount(async () => {
    if (isEmpty($campaignUserStore.campaignUser)) {
      isLoading = true;
      await getCampaignUser();
      isLoading = false;
    }

    // always clear the allow list except for the success page
    clearAllowListExceptTheCurrentRoute(currentRoute.name);
    navigateToAlreadyOrderedPhaseWhenOnAlreadyOrderedPhase($campaignUserStore.campaignUser);
  });

  const onTrackYourGiftButtonClick = () => {
    navigateToPath(PATHS.PROGRESS);
  };

  $: successPageCopyKey = getSuccessPageCopyKey($campaignUserStore.campaignUser);
  $: copy = $getCopy(successPageCopyKey) as Record<string, string>;
  $: successDetails = getSuccessPageData($campaignUserStore.campaignUser);
</script>

<BaseStep {currentRoute} showBackButton={false}>
  <svelte:fragment slot="content">
    {#if isEmpty(successDetails) || isLoading}
      <LoadingScreen />
    {:else}
      <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
      {#if copy.showPromoCode}
        {#if successDetails?.isUrlPromoCode}
          <Typography
            mobile={TypographyType.Body1Medium}
            desktop={TypographyType.Headline2}
            --font-color="var(--subheader-font-color)">
            <h3 class="mt-2 text-center lg:text-left">
              <strong><a href={successDetails.promoCode}>{copy.promoCodeLinkCopy}</a></strong>
            </h3>
          </Typography>
        {:else}
          <Typography
            mobile={TypographyType.Body1Medium}
            desktop={TypographyType.Headline2}
            --font-color="var(--subheader-font-color)">
            <h3 class="mt-2 text-center lg:text-left">
              <strong>{successDetails?.promoCode}</strong>
            </h3>
          </Typography>
        {/if}
      {/if}
      {#if successDetails?.hasEstimatedDelivery && copy.showFulfillment}
        <Typography
          mobile={TypographyType.Body1Medium}
          desktop={TypographyType.Headline2}
          --font-color="var(--subheader-font-color)">
          <p class="mb-8 text-center lg:text-left">{copy.deliveryEstimateLabelCopy}</p>
        </Typography>

        <Typography
          mobile={TypographyType.Body1Medium}
          desktop={TypographyType.Headline2}
          --font-color="var(--color-grayscale-black)">
          <p class="flex gap-2 items-center justify-center lg:justify-start">
            <span> <Clock /></span>
            {copy.deliveryEstimateCopy}
          </p>
        </Typography>
      {/if}

      {#if successDetails?.showTrackYourGiftButton}
        <Button
          class="w-full md:w-fit mt-12"
          primary
          on:click={() => onTrackYourGiftButtonClick()}>
          {copy.trackYourGiftButtonCopy}
        </Button>
      {/if}

      <CustomHtml customHtml={copy.customHtml} />
      <Youtube videoId={copy.videoId} />
    {/if}
  </svelte:fragment>
</BaseStep>
